module.exports = __webpack_public_path__ + "static/media/tooltip.088322c7.svg";